import { Box, Card, CardContent, Typography } from "@mui/material";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ChartTooltip, COLORS } from "../../../ui/Theme";
import { useDomesticMarketMonthlyStockSalesContext } from "../../../context/domestic-market/monthly-stock-sales/DomesticMarketMonthlyStockSalesContext";
import NotFound from "../../../components/notfound/NotFound";
import { ListDivider } from "../../../ui/ListStyles";
import { useMemo } from "react";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length > 0 && payload[0].payload) {
    const data = payload[0].payload;
    const keys = Object.keys(data).filter((key) => key !== "month");

    return (
      <ChartTooltip>
        <Typography sx={{ fontSize: "12px", fontWeight: 900 }}>
          {data.month}
        </Typography>
        <ListDivider flexItem />
        {keys.map((key, index) => (
          <Box
            key={key}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: colorArray[index % colorArray.length],
            }}
          >
            <Typography sx={{ fontSize: "12px" }}>{key} : </Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: 900 }}>
              {data[key]}
            </Typography>
          </Box>
        ))}
      </ChartTooltip>
    );
  }
  return null;
};

const colorArray = [COLORS.ORANGE, COLORS.BLUE, COLORS.GREEN, COLORS.PURPLE];

const DomesticMarketMonthlyStockSalesChart = () => {
  const { chartData } = useDomesticMarketMonthlyStockSalesContext();

  const chartDataKeys = useMemo(() => {
    return chartData && chartData.length > 0
      ? Object.keys(chartData[0]).filter((key) => key !== "month")
      : [];
  }, [chartData]);

  return (
    <Card
      sx={{
        border: "1px solid",
        borderColor: COLORS.SOFTGRAY,
        padding: 0,
        minHeight: 500,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontSize: { xs: "16px", md: "20px" }, fontWeight: 700 }}
        >
          نمودار
        </Typography>

        {chartData.length < 1 ? (
          <Box height={550}>
            <NotFound />
          </Box>
        ) : (
          <ResponsiveContainer width="100%" height={550}>
            <BarChart
              data={chartData}
              margin={{ top: 20, right: 20, bottom: 20, left: 0 }}
            >
              <CartesianGrid strokeDasharray="0 0" stroke={COLORS.SOFTGRAY} />
              <XAxis
                angle={-25}
                textAnchor="middle"
                dataKey="month"
                stroke={COLORS.GRAY}
                tickMargin={10}
              />
              <YAxis textAnchor="start" tickMargin={10} stroke={COLORS.GRAY} />
              <Legend
                verticalAlign="top"
                wrapperStyle={{
                  width: "fit-content",
                  top: -10,
                  right: 0,
                  lineHeight: "20px",
                }}
                formatter={(value) => ` ${value}`}
              />
              <Tooltip cursor={{ fill: COLORS.SOFTGRAY }} content={<CustomTooltip />} />

              {chartDataKeys.map((key, index) => (
                <Bar
                  key={key}
                  barSize={30}
                  dataKey={key}
                  fill={colorArray[index % colorArray.length]}
                  name={key}
                />
              ))}
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default DomesticMarketMonthlyStockSalesChart;
